@if(isLoading)
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser hændelser</h4>
</div>
}
@else
{
<div class="card h-100 card-no-border mt-4">
    <div class="card-body">
        <!-- Header -->
        <div class="row">
            <!-- Search Field -->
            <div class="col-3">
                <app-search-input [(searchText)]="searchText" [placeholder]="'Søg hændelser...'" [autofocus]="true"
                    (searchChange)="search()">
                </app-search-input>
            </div>
        </div>

        <!-- Customer List Table -->
        <div #scrollContainer class="table-wrap-75vh mt-2" (scroll)="onScroll()">
            <table #eventTable class="table table-striped">

                @if(filterEvents.length == 0)
                {
                <thead>
                    <tr>
                        <th class="ms-2 no-data">Ingen hændelser at vise.</th>
                    </tr>
                </thead>
                }
                @else
                {
                <thead class="thead-sticky">
                    <tr>
                        <th class="timestamp-column" scope="col"> Tidspunkt </th>
                        <th style="width: 100px;"> Kategori </th>
                        <th class="flex-fill  "> Beskrivelse </th>
                        <th class="severity-column" scope="col"> Type </th>
                        <th style="width: 44px;"></th>
                        <th style="width: 60px;"></th>
                    </tr>
                </thead>
                }

                <tbody>
                    <!-- For Each Bond -->
                    @for (event of filterEvents; track $index)
                    {
                    <tr class="event-parent-row" [id]="'event-' + event.itemId" (click)="ToggleLogGroup(event)">
                        <td>
                            {{ event.timestamp | date: 'HH:mm dd-MM-yyyy' }}
                        </td>
                        <td>
                            {{ event.customDimensions.feature }}
                        </td>
                        <td>
                            {{ event.message }}
                        </td>
                        <td class="icon-column-td" [innerHTML]="event.severityLevel | severityLevel">
                        </td>
                        <td class="icon-cell">
                            <div class="icon-cell-inner event-expand-cell">
                                <span class="chevron-slot">
                                    <i [hidden]="event.childCount === 0" class="fa-solid fa-chevron-right chevron"
                                        [class.chevron-expanded]="event.showChildren"></i>
                                </span>

                                @if (event.childCount > 0) {
                                <span class="ms-2 text-muted child-count">{{ event.childCount }}</span>
                                }
                            </div>
                        </td>
                        <td class="icon-cell">
                            <div class="icon-cell-inner">
                                @if (event.customDimensions.entityId && event.customDimensions.feature) {
                                <button type="button" class="btn btn-sm btn-primary"
                                    (click)="navigateToEntity(event.customDimensions.feature, event.customDimensions.entityId, $event)"
                                    [ngbPopover]="event.customDimensions.feature | featurePopover"
                                    triggers="hover focus" placement="left" container="body">
                                    <span class="icon-with-badge" aria-hidden="true">
                                        <i [class]="event.customDimensions.feature | featureIcon"></i>
                                        <i class="fas fa-arrow-right badge-icon"></i>
                                    </span>
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                    <tr hidden></tr> <!-- Hidden row to keep the table structure -->
                    <tr class="event-child-row" [class.expanded]="event.showChildren">
                        <td colspan="6" class="child-cell">
                            <div class="child-expand">
                                @if (event.loadingChildren) {
                                <div class="child-expand-inner">
                                    Henter Detaljer...
                                </div>
                                } @else if (event.children.length == 0) {
                                <div class="child-expand-inner">
                                    Ingen Detaljer
                                </div>

                                } @else {
                                <div class="child-expand-inner">
                                    <table class="table mb-3 nested-table">
                                        <thead>
                                            <th class="flex-fill">Detaljer - {{event.customDimensions.user}}
                                                ({{event.userDepartment}})
                                        </thead>
                                        <tbody>
                                            @for (child of event.children; track $index)
                                            {
                                            <tr>
                                                <td>{{child.message}}</td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                }
                            </div>
                        </td>
                    </tr>
                    }

                    @if (isLoadingMore) {
                    <tr>
                        <td colspan="6">
                            <div class="d-flex justify-content-center align-items-center py-2">
                                <div class="continuous-loader" role="status"></div>
                                <span class="ms-2">Indlæser...</span>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>

            <div #scrollSentinel style="height: 1px;"></div>

            @if (!isLoading && filterEvents.length > 0 && !hasMore) {
            <div class="d-flex justify-content-center py-2 text-muted">
                Ikke flere hændelser
            </div>
            }
        </div>
    </div>
</div>
}